export default {
  brand: "USFansSheet",
  nav: {
    home: "Accueil",
    categories: "Catégories",
    guides: "Guides",
    guide: "Guide d'achat",
    faq: "FAQ",
    safety: "Sécurité",
    mainWebsite: "Site principal",
  },
  hero: {
    badge: "Ressource d'achat indépendante",
    title: "La façon la plus intelligente d'explorer la feuille USFans Spreadsheet",
    subtitle: "Parcourez des catégories de produits organisées, des informations sur les vendeurs, des conseils de contrôle qualité, des détails d'expédition et des astuces de sécurité, le tout dans un seul endroit soigné.",
    ctaPrimary: "USFans Spreadsheet",
    ctaSecondary: "Acheter maintenant",
    ctaGuide: "Lire le guide USFans",
    trust: "Ressource indépendante · Mise à jour régulièrement · Multilingue",
  },
  categories: {
    title: "Acheter par catégorie",
    subtitle: "Parcourez chaque catégorie de produits de la feuille USFans Spreadsheet. Choisissez une catégorie pour l'ouvrir sur le site principal.",
    dropdownLabel: "Toutes les catégories",
    dropdownHint: "Sélectionnez une catégorie",
    popularTitle: "Catégories populaires",
    viewAll: "Voir toutes les catégories",
  },
  intro: {
    eyebrow: "Qu'est-ce que c'est",
    title: "Qu'est-ce que la feuille USFans Spreadsheet ?",
    p1: "La feuille USFans Spreadsheet est une référence organisée qui rassemble des listes de produits, des catégories et des détails d'achat dans un format de tableau simple. Au lieu de sauter entre de nombreuses pages, vous ouvrez un seul endroit pour parcourir les articles, vérifier les catégories et trouver les liens dont vous avez besoin.",
    p2: "Notre objectif chez USFansSheet est de faciliter cette recherche, avec des raccourcis clairs vers les catégories, des conseils honnêtes et des astuces utiles sur le contrôle qualité, l'expédition et la sécurité, avant de continuer vers la ressource principale.",
    cta: "Explorer la feuille USFans Spreadsheet",
  },
  articles: {
    eyebrow: "Guides",
    title: "Guides USFans Spreadsheet",
    subtitle: "Lisez des guides originaux et faciles à comprendre pour rechercher des produits, des vendeurs, le contrôle qualité, l'expédition et la sécurité.",
    readMore: "Lire le guide",
    featured: "Guide à la une",
    comingSoon: "Bientôt",
    viewAll: "Voir tous les guides",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Questions fréquentes",
    subtitle: "Réponses rapides aux questions les plus courantes sur la feuille USFans Spreadsheet.",
    q1: "Qu'est-ce que la feuille USFans Spreadsheet ?",
    a1: "C'est un document de référence organisé qui liste des produits, des catégories et des détails d'achat dans un tableau, utilisé comme point de départ pour la recherche.",
    q2: "Comment utiliser la feuille USFans Spreadsheet ?",
    a2: "Ouvrez la catégorie dont vous avez besoin, parcourez les lignes de produits, consultez les notes de contrôle qualité ou d'expédition, puis suivez les liens vers le site principal.",
    q3: "USFans est-il légitime ?",
    a3: "Nous fournissons des informations indépendantes pour vous aider à rechercher. Vérifiez toujours les informations actuelles auprès des sources officielles avant d'acheter.",
    q4: "La feuille couvre-t-elle les frais d'expédition ?",
    a4: "De nombreuses annonces incluent des notes d'expédition, mais les coûts finaux dépendent du poids, de la méthode et de la destination.",
    q5: "Ai-je besoin d'un compte pour naviguer ?",
    a5: "La navigation dans les ressources est généralement ouverte, mais confirmez toujours les exigences de compte sur le site officiel.",
  },
  cta: {
    title: "Prêt à explorer davantage ?",
    subtitle: "Utilisez nos guides pour rechercher USFans, comparer les informations et comprendre les facteurs les plus importants avant de continuer vers la ressource principale.",
    primary: "Visiter le site principal",
    secondary: "Explorer tous les guides",
  },
  footer: {
    description: "USFansSheet est une ressource d'information indépendante centrée sur la feuille USFans Spreadsheet, qui vous aide à rechercher des produits, des catégories, le contrôle qualité, l'expédition et la sécurité.",
    explore: "Explorer",
    resources: "Ressources",
    categories: "Catégories",
    guides: "Guides",
    faq: "FAQ",
    mainWebsite: "Site principal",
    disclaimer: "USFansSheet.guru est une ressource d'information indépendante et n'est pas affiliée ni officiellement approuvée par USFans, sauf indication explicite. Vérifiez toujours les informations actuelles auprès des sources officielles avant de faire des achats ou des décisions financières.",
    rights: "Tous droits réservés.",
  },
  cat: {
    shoes: "Chaussures",
    hoodies: "Hoodies / Sweats",
    tshirts: "T-shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements / Caleçons",
    jersey: "Maillot",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  article: {
    breadcrumbHome: "Accueil",
    breadcrumbGuides: "Guides",
    notFoundTitle: "Guide introuvable",
    notFoundDesc: "Le guide que vous recherchez n'est pas disponible. Revenez à la page d'accueil pour parcourir toutes nos ressources.",
    backHome: "Retour à l'accueil",
    updated: "Mis à jour",
    relatedTitle: "Guides associés",
    ctaTitle: "Poursuivez vos recherches",
    ctaDesc: "Maintenant que vous avez lu ce guide, vous pouvez parcourir les catégories de produits ou accéder directement au site principal pour découvrir la ressource complète.",
    ctaMain: "Visiter le site principal",
  },
};